<div id="my-gauge-container" [style.max-height.px]="maxHeightPx">
    <div #chartContainer id="my-gauge-wrapper" class="prevent-select">
        <highcharts-chart
                *ngIf="gaugeOptions && value != null"
                class="toro-highcharts-chart" [ngClass]="{'fade-in-chart': isGaugeLoaded}"
                [Highcharts]="Highcharts"
                [options]="gaugeOptions"
        ></highcharts-chart>
    </div>
</div>
